export const BUSINESS_DEMO_SUCCESS_SMALL_COMPANY_EVALUATION = {
  "en": "We've evaluated your company's needs and determined that Dashlane Password Management is the best fit.",
  "fr": "",
  "de": "",
  "es": "",
  "pt-br": "We've evaluated your company's needs and determined that Dashlane Password Management is the best fit.",
  "it": "We've evaluated your company's needs and determined that Dashlane Password Management is the best fit.",
  "ja": "We've evaluated your company's needs and determined that Dashlane Password Management is the best fit.",
  "ko": "We've evaluated your company's needs and determined that Dashlane Password Management is the best fit.",
  "nl": "We've evaluated your company's needs and determined that Dashlane Password Management is the best fit.",
  "pt-pt": "We've evaluated your company's needs and determined that Dashlane Password Management is the best fit.",
  "sv": "We've evaluated your company's needs and determined that Dashlane Password Management is the best fit.",
  "zh": "We've evaluated your company's needs and determined that Dashlane Password Management is the best fit."
}